import { createSlice } from '@reduxjs/toolkit';

export const UserInformation = createSlice({
  name: 'UserDetails',
  initialState: {
    phoneNumber: '9876543222',
    firstName: 'Jack',
    lastName: 'Paul',
    dob: '2006-09-05',
    firstSubmitflag: 'true',
  },
  reducers: {
    UserDetails: (state, action) => {
      state.phoneNumber = action.payload.phoneNumber;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.dob = action.payload.dob;
      state.firstSubmitflag = action.payload.firstSubmitflag;
    },
  },
});

export const { UserDetails } = UserInformation.actions;

export default UserInformation.reducer;
